import { render, staticRenderFns } from "./banjiSj.vue?vue&type=template&id=5a811e6e&scoped=true"
import script from "./banjiSj.vue?vue&type=script&lang=js"
export * from "./banjiSj.vue?vue&type=script&lang=js"
import style0 from "./banjiSj.vue?vue&type=style&index=0&id=5a811e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a811e6e",
  null
  
)

export default component.exports